import { useEffect, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

/**
 * Offers a reload when a new build is available.
 *
 * Deliberately not automatic: a rep halfway through typing a site visit should
 * not have the page swapped underneath them. The worker waits until they say so.
 */
export default function UpdatePrompt() {
  const [ready, setReady] = useState(false);
  const [update, setUpdate] = useState(null);

  useEffect(() => {
    let timer;
    let onVisible;
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() { setUpdate(() => updateSW); setReady(true); },
      // The browser only looks for a new build on page load, and a phone app
      // can stay open for days. Also check on return to the app and hourly-ish.
      onRegisteredSW(_url, reg) {
        if (!reg) return;
        const check = () => { if (navigator.onLine) reg.update().catch(() => {}); };
        onVisible = () => { if (!document.hidden) check(); };
        document.addEventListener('visibilitychange', onVisible);
        timer = setInterval(check, 30 * 60 * 1000);
      },
    });
    return () => {
      clearInterval(timer);
      if (onVisible) document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!ready) return null;

  return (
    <div className="update-toast" role="status" aria-live="polite">
      <span>A new version is ready.</span>
      <button onClick={() => update?.(true)}>Reload</button>
    </div>
  );
}
